// extracted by mini-css-extract-plugin
export default {"defaultbutton":"Header_defaultbutton__RECAu"};